import { useTranslation } from "react-i18next";
import styled from "styled-components";

const ModalContainer = styled.div`
  box-shadow: 0px 0px 5px 0px gray;
  background-color: #fefefe;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
`;

const ModalHeader = styled.div`
  background: #c0c0c0;
  color: var(--primary-fg);
  font-weight: 400;
  font-size: 25px;
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
`;

const ModalBody = styled.div`
  display: flex;
  padding: 15px;
  flex-direction: column;
  width: 30vw;
  text-align: left;
`;

const Heading = styled.div`
  font-weight: 400;
  font-size: 20px;
  padding: 20px;
`;

const Message = styled.div`
  font-weight: 400;
  font-size: 13px;
  padding: 1px 20px;
`;

const ModalButton = styled.button`
  background: rgba(0, 0, 0, 0.78);
  box-shadow: 0px 0.75px 1.5px 0px rgba(0, 0, 0, 0.2);
  color: white;
  font-weight: 100;
  font-size: 12px;
  border-radius: 8px;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  margin-bottom: 20px;
`;

type Props = {
  message?: string;
  header?: string;
  onClose: () => void;
};

const ErrorModal = ({ message, header, onClose }: Props): JSX.Element => {
  const { t } = useTranslation();
  return (
    <ModalContainer data-testid="error-modal">
      <ModalHeader>{t("modal.heading")}</ModalHeader>
      <ModalBody data-testid="error-message">
        <Heading>{header || t("error.unknown")}</Heading>
        {message && <Message>{message}</Message>}
      </ModalBody>
      <ModalButton data-testid="close-modal" type="button" onClick={onClose}>
        {t("modal.close_modal")}
      </ModalButton>
    </ModalContainer>
  );
};

export default ErrorModal;
